<template>
  <v-dialog
    v-if="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    max-width="600px"
    persistent
    fullscreen
  >
    <template v-slot:activator="{ on }">
      <v-icon depressed v-on="on">filter_alt</v-icon>
    </template>
    <v-card>
      <v-toolbar dense class="elevation-0 amber darken-1 white--text py-auto">
        <v-toolbar-title class="ml-3">Lọc Tìm Kiếm</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <facility-filter ref="form" @onFilterChanged="onFilterChanged" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import FacilityFilter from '@/modules/facility/FacilityFilter'

export default {
  components: { FacilityFilter },
  props: {},
  data: () => ({
    dialog: false
  }),
  methods: {
    cancel() {
      this.dialog = false
    },
    onFilterChanged(data) {
      this.dialog = data.dialog
      const { dialog, ...query } = data
      this.$emit('onFilterChanged', query)
    }
  }
}
</script>
<style scoped></style>
